import { InjectionToken } from '@angular/core';
import { SubFeatureTogglingRecord } from './feature-toggling.type';

export const FEATURE_TOGGLING = new InjectionToken<SubFeatureTogglingRecord>(
  'FEATURE_TOGGLING'
);
